import { createAction } from 'redux-actions';
import { SET_CAN_SHOW_SUSPENSION_ALERT } from '../constants/actionTypes';
export const setCanShowSuspensionAlert = createAction(SET_CAN_SHOW_SUSPENSION_ALERT, ({
  canShowAlert
}) => ({
  canShowAlert
}));